import moment from "moment";

/**
 * Class for returning the time zone selected by the user or detected in the browser by moment.js.
 */
class TimeZone {
  /**
   * Returns the IANA time zone name as detected in the browser using moment.js.
   *
   * @returns {string} The time zone
   * @example
   *   TimeZone.browser();
   *   // => "America/Chicago"
   */
  static browser() {
    return moment.tz.guess() || "Etc/UTC";
  }

  /**
   * Returns the IANA time zone name selected by the user when there is a select field with
   * the id `time_zone`. Defaults to the browser's time zone if no select field exists.
   *
   * @returns {string} The time zone
   * @example
   *   TimeZone.selected();
   *   // => "America/New_York"
   */
  static selected() {
    const timeZoneSelect = document.querySelector("#time_zone");
    const value = timeZoneSelect ? timeZoneSelect.value : null;

    return value || TimeZone.browser();
  }
}

export default TimeZone;
